import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './theme.css';
import { SessionProvider } from './lib/session';
import { AskProvider } from './components/Ask';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* The outer net: for the case where the shell itself is what failed. */}
    <ErrorBoundary variant="app">
      <BrowserRouter>
        <SessionProvider>
          {/* Inside the session so a dialog can be raised from anywhere behind a login. */}
          <AskProvider>
            <App />
          </AskProvider>
        </SessionProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
